import React, {useState, useEffect} from 'react';
import {
  Typography,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import {db} from '../../db/db.js'

import Wave from 'react-wavify'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const SubscribeView = () => {
  const [isInterested, setIsInterested] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    // Update the document title using the browser API
    if (!isInterested) {
      setFirestoreInterested();
    }
  }, [isInterested]);

  const setFirestoreInterested = async () => {
    alert("hello world")
    const userSnap = await db.collection("users").where("email", "==", "voicefirsttech@gmail.com").get();
    const doc = userSnap.docs[0];
    console.log(doc)
    const data = doc.data();
    console.log(data);
    await doc.ref.set({
      isInterestedInSubscribing: true
    }, {merge: true});
    setIsInterested(true);
  };

  return (
    <Page
      className={classes.root}
      title="Welcome"
    >
      <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
          Subscribe
      </Typography>
      <Wave fill='#EC8074'
            paused={false}
            options={{
              height: 70,
              amplitude: 50,
              speed: 0.45,
              points: 4
            }}
            style={{height: "300px",backgroundColor:'#F4F6F8'}}
      />
    </Page>
  );
};

export default SubscribeView;
